export const QKey = {
  PARTNER_INFO: 'QkeyPartnerInfo',
  BOARD_LIST: 'QkeyBoardList',
  BOARD_DETAIL: 'QkeyBoardDetail',
  NOTI_HIS_LIST: 'QkeyNotiHisList',
  COLD_MAIL_LIST: 'QkeyColdMailList',
  COLD_MAIL_PREVIEW: 'QkeyColdMailPreview',
  FOOD_LIST: 'QkeyFoodList',
  FOOD_DETAIL: 'QkeyFoodDetail',
  FOOD_REQUEST_HISTORIES: 'QkeyFoodRequestHistories',
  FOOD_REQUEST_DETAIL: 'QkeyFoodRequestDetail',
  FOOD_NUTRITION_STANDARDS: 'QkeyFoodNutritionStandards',
  ADMIN_MEMBER_DAILY: 'QkeyAdminMemberDaily',
  ADMIN_MEMBER_MONTHLY: 'QkeyAdminMemberMonthly',
  ADMIN_DIARY_DAILY: 'QkeyAdminDiaryDaily',
  ADMIN_DIARY_MONTHLY: 'QkeyAdminDiaryMonthly',
  ADMIN_SUBSCRIBER_DAILY: 'QkeyAdminSubscriberDaily',
  ADMIN_SUBSCRIBER_MONTHLY: 'QkeyAdminSubscriberMonthly',
  SHARE_CHECK: 'QkeyShareCheck',
  SHARE_DATA: 'QkeyShareData',
  DIARY_DETAIL: 'QkeyDiaryDetail',
} as const;
